import React, { cloneElement, isValidElement } from 'react';

import classes from './SwatchOption.scss';

export type SwatchAttribute = 'Colour' | 'Size';

export function getSwatchAccessibleName(attribute: string, optionName: string): string {
    return `${attribute}: ${optionName}`;
}

type Props = {
    optionName: string;
    attribute?: SwatchAttribute | string;
    input: React.ReactElement;
    visibleLabel?: React.ReactNode;
    labelClassName?: string;
    htmlFor?: string;
} & Omit<React.LabelHTMLAttributes<HTMLLabelElement>, 'children'>;

export const SwatchOption: React.FC<React.PropsWithChildren<Props>> = ({
    optionName,
    attribute = 'Colour',
    input,
    children,
    visibleLabel,
    labelClassName,
    htmlFor,
    ...labelProps
}) => {
    const accessibleName = getSwatchAccessibleName(attribute, optionName);
    const inputElement = input as React.ReactElement<{ 'aria-label'?: string }>;
    const namedInput = isValidElement(input)
        ? cloneElement(inputElement, {
              'aria-label': inputElement.props['aria-label'] ?? accessibleName,
          })
        : input;

    return (
        <label htmlFor={htmlFor} className={labelClassName} {...labelProps}>
            {namedInput}
            {children}
            <span className={classes.visuallyHidden}>{accessibleName}</span>
            {visibleLabel}
        </label>
    );
};
